// extracted by mini-css-extract-plugin
export default {"group":"group-CxNI5YCK","headerText":"headerText-PDCflV8F","container":"container-iM3JunG9"};